module.exports = __webpack_public_path__ + "static/media/gitlab.a776b194.svg";